import { Injectable } from "@nestjs/common";
import { TemperatureLogDto } from "./dto/temperature-log.dto";
import { TemperatureLog } from "./entity/temperature-log.entity";



@Injectable()
export class TemperatureLogAdapter{
    public convertDtoToEntity(tempLogDTO : TemperatureLogDto , isUpdate: boolean = false) : TemperatureLog {
        const tempLog = new TemperatureLog();
        tempLog.tempLogId = tempLogDTO.tempLogId;
        tempLog.loadStatus = tempLogDTO.loadStatus;
        tempLog.uid = tempLogDTO.uid
        tempLog.deptName = tempLogDTO.deptName;
        tempLog.deptCode = tempLogDTO.deptCode;
        tempLog.unitId = tempLogDTO.unitId;
        tempLog.module = tempLogDTO.module;
        tempLog.subModule = tempLogDTO.subModule;
        tempLog.date = tempLogDTO.date;
        tempLog.day = tempLogDTO.day;
        tempLog.month = tempLogDTO.month;
        tempLog.hour = tempLogDTO.hour;
        tempLog.minutes = tempLogDTO.minutes;
        tempLog.temperature = tempLogDTO.temperature;
        tempLog.uom = tempLogDTO.uom;
        tempLog.createdAt = tempLogDTO.createdAt;
        tempLog.createdUser = tempLogDTO.createdUser;
        tempLog.updatedAt = tempLogDTO.updatedAt;
        tempLog.updatedUser = tempLogDTO.updatedUser;
        tempLog.versionFlag = tempLogDTO.versionFlag;
        return tempLog;
    }
    public convertEntityToDto(entityObj :TemperatureLog) : TemperatureLogDto{
        return new TemperatureLogDto(entityObj.tempLogId,entityObj.loadStatus,entityObj.uid,entityObj.deptName,entityObj.deptCode,entityObj.unitId,entityObj.module,entityObj.subModule,entityObj.date,entityObj.day,entityObj.month,entityObj.hour,entityObj.minutes,entityObj.temperature,entityObj.uom,entityObj.createdAt,entityObj.createdUser,entityObj.updatedAt,entityObj.updatedUser,entityObj.versionFlag);
        
    }
}